<!-- NAVBAR START -->
<nav class="navbar navbar-expand-lg py-lg-3 navbar-dark">
    <div class="container">
      <!-- logo -->
      <a href="landing.html" class="navbar-brand mr-lg-5">
        <img
        src="../../../assets/images/logo-white.svg"
          alt=""
          class="logo-dark"
          height="30"
        />
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="mdi mdi-menu"></span>
      </button>

      <!-- menus -->
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <!-- left menu -->
        <ul class="navbar-nav mr-auto align-items-center">
            <li class="nav-item mx-lg-1">
              <a  class="nav-link "  [routerLink]="['/landing']" routerLinkActive="active" >Home</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">Features</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/pricing']" routerLinkActive="active">Pricing</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/faqs']" routerLinkActive="active">FAQs</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/partners']" routerLinkActive="active">Partners</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/contact']" routerLinkActive="active">Contact</a>
            </li>
          </ul>
  
          <!-- right menu -->
          <ul class="navbar-nav ml-auto align-items-center">
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/login']" routerLinkActive="active">Sign Up</a>
            </li>
            <li class="nav-item mx-lg-1">
              <a class="nav-link" [routerLink]="['/login']" routerLinkActive="active">Sign In</a>
            </li>
          </ul>
      </div>
    </div>
  </nav>
  <!-- NAVBAR END -->

  <!-- START HERO -->
  <section class="hero-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center text-white">
            <h3>Get In Touch</h3>
            <p class="mt-2">
              Please fill out the following form and we will get back to you
              shortly. For more <br />information please contact us.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- START CONTACT -->
  <section class="py-5">
    <div class="container">
      <div class="row align-items-center mt-3">
        <div class="col-md-4">
          <p class="text-muted">
            <span class="font-weight-bold">Customer Support:</span><br />
            <span class="d-block mt-1">+713 827 0777</span>
          </p>
          <p class="text-muted mt-4">
            <span class="font-weight-bold">Email Address:</span><br />
            <span class="d-block mt-1">sales&#64;wiseit.com</span>
          </p>
          <p class="text-muted mt-4">
            <span class="font-weight-bold">Office Address:</span><br />
            <span class="d-block mt-1">10810 Katy Freeway</span>
            <span class="d-block mt-1">Suite 103</span>
            <span class="d-block mt-1">Houston, TX 77043</span>
          </p>
          <p class="text-muted mt-4">
            <span class="font-weight-bold">Office Time:</span><br />
            <span class="d-block mt-1">9:00AM To 6:00PM</span>
          </p>
        </div>

        <div class="col-md-8">
          <form>
            <div class="row mt-4">
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="fullname">Your Name</label>
                  <input
                    class="form-control form-control-light"
                    type="text"
                    id="fullname"
                    placeholder="Name..."
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="emailaddress">Your Email</label>
                  <input
                    class="form-control form-control-light"
                    type="email"
                    required=""
                    id="emailaddress"
                    placeholder="Enter you email..."
                  />
                </div>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-lg-12">
                <div class="form-group">
                  <label for="subject">Your Subject</label>
                  <input
                    class="form-control form-control-light"
                    type="text"
                    id="subject"
                    placeholder="Enter subject..."
                  />
                </div>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-lg-12">
                <div class="form-group">
                  <label for="comments">Message</label>
                  <textarea
                    id="comments"
                    rows="4"
                    class="form-control form-control-light"
                    placeholder="Type your message here..."
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12 text-right">
                <button class="btn btn-primary">
                  Send a Message <span class="mdi mdi-telegram ml-1"></span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <!-- END CONTACT -->
  <!-- END HERO -->

  <!-- START FOOTER -->
  <footer class="bg-dark py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <img
          src="../../../assets/images/logo-white.svg"
            alt=""
            class="logo-dark"
            height="30"
          />
          <p class="text-white-50 mt-4">
            Hyper makes it easier to build better websites with <br />
            great speed. Save hundreds of hours of design <br />
            and development by using it.
          </p>

          <ul class="social-list list-inline mt-3">
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-primary text-primary"
                ><span class="mdi mdi-facebook"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-danger text-danger"
                ><span class="mdi mdi-google"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-info text-info"
                ><span class="mdi mdi-twitter"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-secondary text-secondary"
                ><span class="mdi mdi-github-circle"></span
              ></a>
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Company</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >About Us</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Documentation</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50">Blog</a>
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Affiliate Program</a
              >
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Apps</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Ecommerce Pages</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50">Email</a>
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Social Feed</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Projects</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Tasks Management</a
              >
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Discover</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Help Center</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Our Products</a
              >
            </li>
            <li class="mt-2">
              <a href="privacy.html" class="text-white-50">Privacy</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="mt-5">
            <p class="text-white-50 mt-4 text-center mb-0">
              © 2018 - 2020 Hyper. Design and coded by Coderthemes
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- END FOOTER -->